/* 🤖 this file was generated by svg-to-ts */
export const matIconAccessibility: {
  name: 'accessibility';
  data: string;
} = {
  name: 'accessibility',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M12 2c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm9 7h-6v13h-2v-6h-2v6H9V9H3V7h18v2z"/></svg>`
};
